import { useMemo } from "react";
import { usePortfoliosCRUD } from "@/pages/PortfolioBuilder/api/usePortfoliosCRUD";
import { useHeadlineQueriesCRUD } from "@/widget-components/newsquawk-headlines/api/headline-query/useHeadlineQueriesCRUD";
import { useTagsWatchlistsCRUD } from "@/shared/api/pref-storage/tags-watchlists/useTagsWatchlistsCRUD";
import type { NewsquawkIdSets } from "@/utils/layoutExportImport";

export function useNewsquawkOwnedIds(): NewsquawkIdSets {
  const { portfolios } = usePortfoliosCRUD();
  const { queriesQuery } = useHeadlineQueriesCRUD();
  const { watchlistsQuery } = useTagsWatchlistsCRUD();

  return useMemo(() => {
    const portfolioIds = new Set<string>(
      portfolios
        .filter((p) => p.owner_type === "NEWSQUAWK")
        .map((p) => String(p.id))
    );

    const headlineQueryIds = new Set<string>(
      (queriesQuery.data ?? [])
        .filter((q) => q.owner_type === "NEWSQUAWK")
        .map((q) => String(q.id))
    );

    const tagWatchlistIds = new Set<string>(
      (watchlistsQuery.data ?? [])
        .filter((w) => w.owner_type === "NEWSQUAWK")
        .map((w) => String(w.id))
    );

    return { portfolioIds, headlineQueryIds, tagWatchlistIds };
  }, [portfolios, queriesQuery.data, watchlistsQuery.data]);
}
